import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ShieldCheck } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-extrabold text-slate-900 mb-2">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-2 text-[15px]">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <div className="App min-h-screen bg-white" data-testid="privacy-page">
      <Header />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-3">
          <ShieldCheck className="w-4 h-4" /> RGPD
        </div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tighter font-extrabold text-slate-900">
          Politique de confidentialité
        </h1>
        <p className="mt-3 text-slate-500">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}</p>

        <div className="mt-10">
          <Section title="1. Responsable du traitement">
            <p>
              Le présent site « Les Yeux Dans L'Immo » collecte et traite des données personnelles en tant
              que responsable de traitement. Contact : <a href="mailto:lesyeuxdanslimmo@gmail.com" className="text-[#2563EB] underline">lesyeuxdanslimmo@gmail.com</a>.
            </p>
          </Section>

          <Section title="2. Données collectées">
            <p>Dans le cadre d'une demande d'estimation, nous collectons :</p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Vos coordonnées : nom, adresse email, numéro de téléphone ;</li>
              <li>Les informations sur le bien : type, localisation, surface, état, etc. ;</li>
              <li>Votre projet (délai de vente envisagé, souhait d'être recontacté par un conseiller).</li>
            </ul>
          </Section>

          <Section title="3. Finalités et base légale">
            <p>Vos données sont utilisées pour :</p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Réaliser et vous transmettre votre avis de valeur (exécution de votre demande) ;</li>
              <li>Vous mettre en relation avec un professionnel de l'immobilier partenaire local afin d'affiner l'estimation de votre bien (votre consentement) ;</li>
              <li>Améliorer notre service et nos statistiques (intérêt légitime).</li>
            </ul>
          </Section>

          <Section title="4. Destinataires">
            <p>
              Vos données sont destinées à Les Yeux Dans L'Immo, à ses prestataires techniques
              (hébergement, envoi d'emails), ainsi qu'à nos professionnels de l'immobilier partenaires
              (agents immobiliers, conseillers ou mandataires locaux) sur votre secteur géographique, dans le
              cadre strict du traitement de votre estimation. Vos données ne sont en aucun cas revendues à des
              tiers étrangers à votre projet immobilier.
            </p>
          </Section>

          <Section title="5. Durée de conservation">
            <p>
              Vos données sont conservées pour la durée nécessaire au traitement de votre demande et à la
              relation commerciale, puis archivées ou supprimées conformément à la réglementation en vigueur
              (généralement 3 ans après le dernier contact).
            </p>
          </Section>

          <Section title="6. Vos droits">
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de
              limitation, d'opposition et de portabilité de vos données. Pour exercer ces droits, écrivez-nous
              à <a href="mailto:lesyeuxdanslimmo@gmail.com" className="text-[#2563EB] underline">lesyeuxdanslimmo@gmail.com</a>.
              Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
            </p>
          </Section>

          <Section title="7. Cookies">
            <p>
              Ce site utilise des cookies de mesure d'audience et, le cas échéant, de suivi publicitaire
              (Google Ads). Vous pouvez accepter ou refuser ces cookies via le bandeau prévu à cet effet et
              paramétrer votre navigateur pour les bloquer.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
